<!-- <p>badminton-tournament works!</p> -->

<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Chess Championship</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chess2021 section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2>Nagpur District Under 13 Open and Girls Selection<span>Chess Championship 2025 </span></h2>
        </div>

        <div class="row text-justify">
            <div class="col-lg-12">
                <p>
                    The Nagpur District Under 13 Open and Girls Selection Chess Championship 2025, organized
                    by Chess Association Nagpur in association with G.H. Raisoni Sports and Cultural Foundation,
                    MKH Sancheti Group, and Kalpana Prakash Welfare Foundation, was successfully held on 19th
                    January 2025 at Vivekanand Hall, Shraddha House, Kingsway, Near Kasturchand Park,
                    Nagpur.
                </p>
                <p>The tournament witnessed intense competition in the Rapid Format (15 minutes + 5 seconds
                    increment per move), with the first round commencing at 9:30 AM. The number of rounds was
                    determined based on total entries.</p>
                <p><strong>Top Players Selected for State Championship</strong></p>
                <p>The top two players in the Open and Girls categories have been selected to represent Nagpur
                    District in the upcoming Maharashtra State Under 13 Open and Girls Chess Championship
                    2025.</p>
                <p><strong>Prizes and Sponsorship</strong></p>
                <p>A total of ₹10,000 in cash prizes, sponsored by MKH Sancheti Group, was awarded to the
                    winners.</p>
                <p><strong>Support for Selected Players</strong></p>
                <p>The entry fees of the selected players for the Maharashtra State Under 13 Chess Championship
                    2025 will be reimbursed by Chess Association Nagpur. Additionally, apart from the selected
                    players, only the names of participants from this Official Selection Event will be recommended for
                    participation in the Maharashtra State Selection Chess Championship 2025 as donor entries.</p>
                    <p>We congratulate all participants and extend our best wishes to the selected players for their
                        upcoming state-level matches!</p>
            </div>


        </div>



    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="border-line-sm"></div>
        <div class="row row-cols-1 row-cols-md-2">
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Media Coverage</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-1.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-1.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-1.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-2.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-2.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/open-selction-womens-2.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div class="gall-ery">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="widget_title inner-title gall-sys shadow-text-sm">
                                <h4 class="fw-bold">Photos</h4>
                            </div>
                        </div>
                        <div class="col-md-4 text-end">
                            <!-- <a href="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/swiming-meet.pdf" target="_blank" class="btn button--effect-1 v-more"><span>
									View More</span> <i class="fa fa-caret-square-o-right" aria-hidden="true"></i>
							</a> -->
                        </div>
                    </div>
                    <div class="lightBox--gallery">
                        <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-3">

                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-3.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                            <li
                                class="col"
                                data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                                data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif"
                            >
                                <a href="Javascript:void(0);">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/womens-chess-4.avif" alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                                    <div class="light-gallery-poster">
                                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
